<script>
export default {
    name: 'IconLess'
}
</script>
<template>
    <svg
        class="base-icon icon-less"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path fill="currentColor" d="M52 29v6H12v-6z" fill-rule="evenodd" />
    </svg>
</template>
